import get from 'lodash/get';

import {
  VAULT_ACCOUNT_TYPES,
  UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE,
} from '../../constants/payments/vault-account-types';

export const isCardExpired = (mmyy, now = new Date()) => {
  const month = Number(mmyy.slice(0, 2));
  const year = Number(mmyy.slice(2, 4));

  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;

  const centuryBase = Math.floor(currentYear / 100) * 100;
  const fullYear = centuryBase + year;

  if (fullYear < currentYear) return true;
  if (fullYear === currentYear && month < currentMonth) return true;

  return false;
};

const formatExpiryMMYY = mmyy => {
  const month = mmyy.slice(0, 2);
  const year = mmyy.slice(2, 4);
  return `${month}/${year}`;
};

const mapAccountVaultCardsToItems = item => {
  const accountType = get(
    VAULT_ACCOUNT_TYPES,
    `${item.accountType}`,
    UNKNOWN_VAULT_ACCOUNT_TYPE_TITLE,
  );

  return {
    accountType,
    expDate: formatExpiryMMYY(item.expDate),
    id: item.id,
    isExpired: isCardExpired(item.expDate),
    label: `**** **** **** ${item.lastFour}`,
    usedByDefault: item.usedByDefault,
    hasActiveSubscriptions: item.hasActiveSubscriptions,
    value: item.id,
  };
};

export default mapAccountVaultCardsToItems;



// WEBPACK FOOTER //
// ./src/utils/converters/map-account-vault-cards-to-items.js